import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [5.31188633046],
    [0.0179847553, 2.9010127389, 38.1330356378],
    [0.01019727652, 0.48580922867, 1.4844727083],
    [0.00124531845, 4.83008090676, 36.6485629295],
    [0.00042064466, 5.41054993053, 2.9689454166],
    [0.00037714584, 6.09221808686, 35.1640902212],
    [0.00033784738, 1.24488874087, 76.2660712756],
    [0.00016482741, 0.00007727998, 491.5579294568],
    [0.00009198584, 4.93747051954, 39.6175083461],
    [0.0000899425, 0.27462171806, 175.1660598002],
    [0.00004216242, 1.98711875978, 73.297125859],
    [0.00003364807, 1.03590060915, 33.6796175129],
    [0.000022848, 4.20606949415, 4.4534181249],
    [0.00001433516, 2.78339802539, 74.7815985673],
    [0.00000900236, 2.07607168714, 109.9456887885],
    [0.00000744997, 3.19032509437, 71.8126531507],
    [0.00000506217, 5.7478606968, 114.3991069134],
    [0.00000399552, 0.34972342836, 1021.2488945514],
    [0.00000345189, 3.46185292806, 41.1019810544],
    [0.00000340303, 3.30376245107, 77.7505439839],
    [0.00000323003, 2.24814943701, 32.1951448046],
    [0.00000306338, 0.49684052934, 0.5212648618],
    [0.00000287322, 4.50523446022, 0.0481841098],
    [0.0000028217, 2.2456558998, 146.594251718],
    [0.00000266605, 4.8893260559, 0.9632078465],
    [0.00000251941, 5.78166617117, 388.4651552382],
    [0.00000244722, 1.24693366148, 9.5612275556],
    [0.00000232888, 2.50459784128, 137.0330241624],
    [0.00000227079, 1.79713146385, 453.424893819],
    [0.00000170404, 3.32390687638, 108.4612160802],
    [0.00000151401, 2.19153150087, 33.9402499438],
    [0.00000150188, 2.99706170691, 5.9378908332],
    [0.00000148305, 0.85949274408, 111.4301614968],
    [0.00000118672, 3.67706211426, 2.4476805548],
    [0.00000109299, 2.41599473953, 183.2428146475],
    [0.00000103305, 0.04078966679, 0.2606324309],
    [0.00000103059, 4.40432042649, 70.3281804424],
    [0.00000101821, 5.70539236951, 0.1118745846],
];

const VSOP87_L1: Vsop87Element = [
    [38.13303563957],
    [0.00016604172, 4.86323329249, 1.4844727083],
    [0.00015744045, 2.27887427527, 38.1330356378],
    [0.00001306261, 3.6728520962, 2.9689454166],
    [0.00000604842, 1.5048304279, 35.1640902212],
    [0.00000195106, 0.88660326088, 76.2660712756],
    [0.00000182909, 3.45225794434, 39.6175083461],
    [0.0000010641, 2.44986610969, 4.4534181249],
    [0.0000010559, 2.75516054635, 33.6796175129],
    [0.00000072757, 5.49395347003, 36.6485629295],
    [0.00000057069, 5.2164980497, 0.5212648618],
    [0.00000029871, 3.67043294114, 388.4651552382],
    [0.00000028866, 5.16877538898, 9.5612275556],
    [0.00000028742, 5.16732589024, 2.4476805548],
];

const VSOP87_L2: Vsop87Element = [
    [0.0000029565, 1.85520880574, 1.4844727083],
    [0.00000286136, 1.18985661922, 38.1330356378],
    [0.00000102284],
    [0.00000022987, 1.21060882957, 2.9689454166],
    [0.00000009112, 4.42541280638, 35.1640902212],
    [0.00000007332, 0.53982718012, 2.4476805548],
    [0.00000005223, 0.67422237527, 168.0525127994],
    [0.00000005201, 3.02334762854, 182.279606801],
    [0.00000003925, 3.53215364421, 484.444382456],
];

const VSOP87_L3: Vsop87Element = [
    [0.00000012472, 6.04427218715, 1.4844727083],
    [0.00000011257, 6.11436681584, 38.1330356378],
    [0.0000000139, 4.95198243861, 2.9689454166],
    [0.00000000745, 2.37751238105, 168.0525127994],
];

const VSOP87_L4: Vsop87Element = [];

const VSOP87_L5: Vsop87Element = [];

const VSOP87_B0: Vsop87Element = [
    [0.03088622933, 1.44104372644, 38.1330356378],
    [0.00027780087, 5.91271884599, 76.2660712756],
    [0.00027623609],
    [0.00015448133, 3.50877079215, 39.6175083461],
    [0.00015355489, 2.52123799551, 36.6485629295],
    [0.00001999918, 1.50998668632, 74.7815985673],
    [0.0000196754, 4.37778196626, 1.4844727083],
    [0.00001015137, 3.21560997434, 35.1640902212],
    [0.00000605767, 2.80246592015, 73.297125859],
    [0.00000594878, 2.12892696997, 41.1019810544],
    [0.00000588806, 3.18655898167, 2.9689454166],
    [0.0000040183, 4.16883411107, 114.3991069134],
    [0.00000279963, 1.68165289071, 77.7505439839],
    [0.00000261647, 3.76722702982, 213.299095438],
    [0.00000254333, 3.27120475878, 453.424893819],
    [0.0000020559, 4.25652269561, 529.6909650946],
    [0.00000140455, 3.52969120587, 137.0330241624],
    [0.0000009853, 4.16774786185, 33.6796175129],
    [0.00000067971, 4.66970488716, 71.8126531507],
];

const VSOP87_B1: Vsop87Element = [
    [0.00005150897, 2.14270496419, 38.1330356378],
    [0.00000258298, 5.4653959892, 76.2660712756],
    [0.00000251862, 4.40444268588, 36.6485629295],
    [0.00000234436, 1.65983511437, 39.6175083461],
    [0.00000208814],
    [0.00000025312, 6.00917621033, 35.1640902212],
    [0.00000017841, 0.44821000048, 41.1019810544],
    [0.00000017795, 4.95721064558, 213.299095438],
];

const VSOP87_B2: Vsop87Element = [
    [0.00000042058, 1.91480759314, 38.1330356378],
    [0.00000004359, 4.77459417163, 39.6175083461],
    [0.0000000423, 1.12991232222, 36.6485629295],
    [0.00000004166, 4.37185631758, 76.2660712756],
];

const VSOP87_B3: Vsop87Element = [[0.00000004131, 3.06928911462, 38.1330356378]];

const VSOP87_B4: Vsop87Element = [];

const VSOP87_B5: Vsop87Element = [];

const VSOP87_R0: Vsop87Element = [
    [30.07013205828],
    [0.27062259632, 1.32999459377, 38.1330356378],
    [0.01691764014, 3.25186135653, 36.6485629295],
    [0.00807830553, 5.18592878704, 1.4844727083],
    [0.0053776051, 4.52113935896, 35.1640902212],
    [0.00495725141, 1.5710564165, 491.5579294568],
    [0.00274571975, 1.84552258866, 175.1660598002],
    [0.00135134092, 3.37220609835, 39.6175083461],
    [0.00121801746, 5.79754470298, 76.2660712756],
    [0.00100896068, 0.3770272493, 73.297125859],
    [0.00069791331, 3.79616637768, 2.9689454166],
    [0.00046687836, 5.74938034313, 33.6796175129],
    [0.00024594531, 0.50801745878, 109.9456887885],
    [0.00016939478, 1.59422512526, 71.8126531507],
    [0.00014229808, 1.07785898723, 74.7815985673],
    [0.0001201232, 1.92059384991, 1021.2488945514],
    [0.00008394349, 0.67818233586, 146.594251718],
    [0.00007571796, 1.07149207335, 388.4651552382],
    [0.00005720872, 2.59061733345, 4.4534181249],
    [0.0000484021, 1.90681013048, 41.1019810544],
    [0.00004483493, 2.90573464537, 529.6909650946],
    [0.00004420549, 1.74990681127, 108.4612160802],
    [0.00004353588, 0.67984856103, 32.1951448046],
    [0.00004269595, 3.4133352687, 453.424893819],
    [0.00003381113, 0.84810966225, 183.2428146475],
    [0.00002879755, 1.98627174527, 137.0330241624],
    [0.00002877511, 3.67417203197, 350.3321196004],
];

const VSOP87_R1: Vsop87Element = [
    [0.00236338618, 0.70497954792, 38.1330356378],
    [0.00013220034, 3.3201438793, 1.4844727083],
    [0.00008621779, 6.21626927537, 35.1640902212],
    [0.00002701587, 1.88124996531, 39.6175083461],
    [0.0000215417, 2.0943033339, 2.9689454166],
    [0.0000215306, 5.16877044933, 76.2660712756],
    [0.00001603164],
    [0.00001463314, 1.18410155089, 33.6796175129],
    [0.00001135663, 3.91905853528, 36.6485629295],
    [0.0000089765, 5.24122933533, 388.4651552382],
    [0.00000789359, 0.53295000718, 168.0525127994],
    [0.0000076003, 0.02051033644, 182.279606801],
];

const VSOP87_R2: Vsop87Element = [
    [0.00004247776, 5.89911844921, 38.1330356378],
    [0.00000217404, 0.34589546713, 1.4844727083],
    [0.00000163025, 2.2387294713, 168.0525127994],
];

const VSOP87_R3: Vsop87Element = [[0.00000166556, 4.55393495836, 38.1330356378]];

const VSOP87_R4: Vsop87Element = [];

const VSOP87_R5: Vsop87Element = [];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];
export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];
export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
